// /admin/v1/users/:id/membership — 用户会员身份 + 订阅历史 + 钻石批次 + 支付审计.
//
// 只读端点. is_member 判定逻辑与 /me 一致 (status=active AND expires_at>now).

import { get } from './client';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface MembershipStatus {
  /** 是否有效会员 (status=active AND expires_at>now) */
  is_member: boolean;
  /** 会员档位 — SKU code (e.g. membership_weekly | membership_monthly | membership_yearly) */
  tier?: string;
  /** 订阅到期时间 (ISO 8601) */
  member_expires_at?: string | null;
  /** 宽限期截止 (= expires_at + 7d) */
  grace_until?: string | null;
}

export interface SubscriptionRow {
  id: string;
  app_id: number;
  sku_id: number;
  status: string;
  started_at: string;
  expires_at: string;
  auto_renew: boolean;
  cycle_count: number;
  last_order_id?: string | null;
  created_at: string;
}

export interface DiamondLotRow {
  id: string;
  /** subscription_grant | addon_purchase | admin_grant | refund | migration_backfill */
  source_reason: string;
  initial: number;
  remaining: number;
  expire_at?: string | null;
  grace_until?: string | null;
  ref_id?: string | null;
  created_at: string;
}

export interface OrderAuditRow {
  id: string;
  out_trade_no: string;
  sku_id: number;
  channel: string;
  amount_cents: number;
  status: string;
  paid_at?: string | null;
  created_at: string;
}

export interface TopupTxRow {
  id: number;
  provider: string;
  transaction_id: string;
  product_id: string;
  diamonds: number;
  status: string;
  created_at: string;
}

export interface UserMembershipDetail {
  membership: MembershipStatus;
  subscriptions: SubscriptionRow[];
  diamond_lots: DiamondLotRow[];
  orders: OrderAuditRow[];
  topup_transactions: TopupTxRow[];
}

// ---------------------------------------------------------------------------
// API
// ---------------------------------------------------------------------------

/** GET /admin/v1/users/:id/membership */
export function getUserMembership(userId: string): Promise<UserMembershipDetail> {
  return get<UserMembershipDetail>(`/admin/v1/users/${userId}/membership`);
}
